import React from "react";
import "./Footer.css";

function Footer() {
  return (
    <footer>
      <span>
        Created By :{" "}
        <a
          href="https://www.linkedin.com/in/karthick-raja-s/"
          target="_blank"
          rel="noreferrer"
          style={{ textDecoration: "none" }}
        >
          S.Karthick Raja 💖
        </a>{" "}
      </span>
    </footer>
  );
}

export default Footer;
